import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { ExitActionController } from './exit-action.controller';
import { ExitActionAdapter } from './dto/exit-action.adapter';
import { ExitAction } from './exit-action.entity';
import { ExitActionService } from './exit-action.service';


@Module({
    imports:[
        TypeOrmModule.forFeature([ExitAction]),
    ],
    controllers: [ExitActionController],
    providers: [ExitActionService, ExitActionAdapter, ApplicationExceptionHandler],
    exports: [ExitActionService]
})
export class ExitActionModule {}
